/**
 * Payload for the generation-status write. A new running write clears a
 * leftover timeout or other aiGenerateError so the next run is not swallowed.
 */
export type GenerationStatusInput = {
    enhanced: 'done' | 'pending' | 'processing' | null;
    aiGenerateStatus: 'done' | 'failed' | 'running' | 'review' | null;
};

export type GenerationStatusWrite = GenerationStatusInput & {
    aiGenerateError?: null;
};

export function generationStatusWrite(data: GenerationStatusInput): GenerationStatusWrite {
    const payload: GenerationStatusWrite = {
        enhanced: data.enhanced,
        aiGenerateStatus: data.aiGenerateStatus,
    };
    if (data.aiGenerateStatus === 'running') {
        payload.aiGenerateError = null;
    }
    return payload;
}
